import { AuthLevel, generateApiPath } from '@guiker/api-definition'

export const paths = {
  recommendedListings: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'recommended-listing' }),
}
